import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Nebraska State Portal": {
    parameters: {
      linkUrls: ["https://deq-iis.ne.gov/tier2/"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "NE",
  },
};
